<template>
  <div class="w-full bg-white font-poppins">
    <ToastAlert
      :is-active="toastAlert"
      :type="typeMsg"
      :message="msg"
      :title="tittle"
    />
    <ConfirmCancelModal 
      :is-visible="showCancelModal"
      @cancel="showCancelModal = false"
      @confirm="confirmCancelSuscription"
    />
    <div v-show="!showPayments">
      <!-- LOADER -->
      <div v-if="loader_profile" class="fixed inset-0 flex items-center justify-center bg-white  z-50">
        <img
          src="@/assets/imgs/tuin_loader_v2.gif"
          alt="cargando..."
          class=" w-[500px]"
        >
      </div>
      <!-- LOADER -->
      <div v-if="!loader_profile" class="relative">
        <div class="flex items-center justify-center">
          <div class="p-4">
            <div class="flex">
              <div class="self-stretch h-8 justify-center text-black text-lg font-medium font-['Poppins'] leading-snug">
                Suscripciones
              </div>
            </div>
            <div class="mt-4 sm:mt-1">
              <div class=" h-8 justify-center text-neutral-500 text-base font-medium font-['Poppins'] leading-tight">
                <span>
                  No tienes ninguna suscripción activa en este momento. <br> ¡Comienza ahora para disfrutar de todos nuestros beneficios!
                </span>   
              </div>
            </div>
            <div class="p-4 flex flex-col items-center">
              <div class="w-72 h-64 relative overflow-hidden mt-8"> <!-- mt-8 = 2rem = 32px -->
                <img
                  src="@/assets/imgs/icons/Home_pagos.svg"
                  alt="Pagos"
                  class="w-full h-full object-contain"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="p-4 flex flex-col items-center">
          <fwb-button
            @click="triggerPlanesTab"
            :disabled="!isActiveLocation"
            class="w-72 px-5 py-2.5 bg-rose-500 rounded-lg outline outline-1 outline-offset-[-1px] outline-rose-500 inline-flex justify-center items-center gap-2 overflow-hidden disabled:opacity-50 cursor-pointer"
          >
            <div class="w-5 h-5 relative overflow-hidden">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="white" class="w-5 h-5">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.5 5.5C10.7652 5.5 11.0196 5.60536 11.2071 5.79289C11.3946 5.98043 11.5 6.23478 11.5 6.5V9.5H14.5C14.7652 9.5 15.0196 9.60536 15.2071 9.79289C15.3946 9.98043 15.5 10.2348 15.5 10.5C15.5 10.7652 15.3946 11.0196 15.2071 11.2071C15.0196 11.3946 14.7652 11.5 14.5 11.5H11.5V14.5C11.5 14.7652 11.3946 15.0196 11.2071 15.2071C11.0196 15.3946 10.7652 15.5 10.5 15.5C10.2348 15.5 9.98043 15.3946 9.79289 15.2071C9.60536 15.0196 9.5 14.7652 9.5 14.5V11.5H6.5C6.23478 11.5 5.98043 11.3946 5.79289 11.2071C5.60536 11.0196 5.5 10.7652 5.5 10.5C5.5 10.2348 5.60536 9.98043 5.79289 9.79289C5.98043 9.60536 6.23478 9.5 6.5 9.5H9.5V6.5C9.5 6.23478 9.60536 5.98043 9.79289 5.79289C9.98043 5.60536 10.2348 5.5 10.5 5.5Z"
                />
              </svg>
            </div>
            <span class="justify-start text-white text-sm font-medium font-['Inter'] leading-tight">
              Activar suscripción
            </span>
          </fwb-button>
        </div>
      </div>
    </div>
    <div v-if="showPayments"> 
      <div v-if="type_plan === 9" class="flex flex-col items-center justify-center px-4 py-8">
        <div class="w-full max-w-2xl">
          <!-- Header Plan Free -->
          <div class="text-center mb-8">
            <div class="text-rose-500 text-2xl font-medium font-['Poppins'] mb-2">
              Plan Free
            </div>
            <div class="text-neutral-500 text-base font-medium font-['Poppins']">
              Estás usando la versión free de Tuin
            </div>
          </div>

          <!-- Card Plan Free -->
          <div class="w-full p-8 bg-white rounded-2xl shadow-md outline outline-1 outline-gray-200 mb-6">
            <div class="flex flex-col items-center gap-6">
              <!-- Icono o imagen -->
              <div class="w-32 h-32">
                <img
                  src="@/assets/imgs/icons/Home_pagos.svg"
                  alt="Plan Free"
                  class="w-full h-full object-contain"
                />
              </div>

              <!-- Beneficios del plan free -->
              <div class="w-full">
                <div class="text-gray-900 text-lg font-medium font-['Poppins'] mb-4 text-center">
                  Tu plan incluye:
                </div>
                <div class="flex flex-col gap-3">
                  <div class="flex items-center gap-3">
                    <div class="w-5 h-5 flex items-center justify-center">
                      <div class="w-3.5 h-3.5 bg-gray-400 rounded-sm"></div>
                    </div>
                    <div class="text-gray-500 text-base font-normal font-['Poppins']">
                      Acceso a las funciones básicas.
                    </div>
                  </div>
                  <div class="flex items-center gap-3">
                    <div class="w-5 h-5 flex items-center justify-center">
                      <div class="w-3.5 h-3.5 bg-gray-400 rounded-sm"></div>
                    </div>
                    <div class="text-gray-500 text-base font-normal font-['Poppins']">
                      Vizualización de la bolsa inmobiliaria de TUIN
                    </div>
                  </div>
                </div>
              </div>

              <!-- Botón CTA -->
              <fwb-button
                @click="triggerPlanesTab"
                :disabled="!isActiveLocation"
                class="w-full px-5 py-3 bg-rose-500 rounded-lg flex justify-center items-center gap-2 hover:bg-rose-600 transition-colors"
              >
                <span class="text-white text-base font-medium font-['Poppins']">
                  Cambiar de plan
                </span>
              </fwb-button>

              <!-- Mensaje motivacional -->
              <div class="text-center text-sm text-gray-500 font-['Poppins']">
                Desbloquea todas las funciones con un plan de pago
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Vista normal para planes de pago -->
      <div v-else>
        <div v-if="!loader_profile" class="flex flex-col lg:flex-row justify-start items-start gap-8 lg:gap-[165px] mt-16 lg:mt-10 px-4 sm:px-8 lg:px-[91px]">
          <!-- Sección Izquierda: Detalles de la Cuenta -->
          <div class="w-full lg:w-[492px] inline-flex flex-col justify-start items-start gap-8">
            <div class="self-stretch flex flex-col justify-start items-start gap-4">
              <div class="w-full lg:w-80 flex flex-col justify-start items-start gap-[5px]">
                <div class="self-stretch h-8 justify-start text-rose-500 text-xl font-medium font-['Poppins'] leading-7">Suscripción Mensual</div>
                <div class="self-stretch h-8 justify-start text-black text-lg font-medium font-['Poppins'] leading-snug">Detalles de la cuenta</div>
              </div>
            </div>
              <div class="self-stretch min-h-32 bg-white rounded-lg shadow-[0px_2px_4px_-2px_rgba(0,0,0,0.05)] shadow-md overflow-hidden p-4 lg:p-6 flex flex-col justify-between gap-3">
              <div class="flex flex-col gap-2 w-full">
                <div class="w-full text-black text-lg font-medium font-['Poppins'] leading-snug break-words">{{ plan_name }}</div>
                <div v-if="!scheduled_cancellation" class="w-full text-black text-base font-medium font-['Poppins'] leading-tight"> Siguiente cobro el {{ next_payment }} </div>
                <div v-else class="w-full text-red-600 text-base font-medium font-['Poppins'] leading-tight"> Tu plan terminará el {{ next_payment }} y no se volverá a cobrar. </div>
              </div>
              <div class="flex items-center gap-3 w-full">
                <div class="w-10 h-10 flex items-center justify-center flex-shrink-0">
                  <img
                    :src="getCardLogo(type_card)"
                    alt="Card Logo"
                    class="w-10 h-auto object-contain"
                  />
                </div>
                <div class="text-black text-base font-medium font-['Poppins'] leading-tight">**** **** **** {{ last4_number }}</div>
              </div>
            </div>
            </div>
            
            <!-- Sección Derecha: Card del Plan -->
            <div
              class="w-full lg:w-96 p-6 sm:p-8 bg-white rounded-2xl shadow-[0px_2px_4px_-2px_rgba(0,0,0,0.05)] shadow-md outline outline-1 outline-offset-[-1px] outline-gray-200 flex flex-col justify-start items-center gap-6 sm:gap-7 overflow-hidden"
            >
              <!-- Nombre del Plan -->
              <div class="flex flex-col items-center sm:items-start w-full gap-4">
                <div class="text-gray-500 text-lg sm:text-xl font-medium font-['Poppins'] leading-snug text-center sm:text-left">
                  {{ plan_name }}
                </div>

                <div class="flex flex-wrap justify-center sm:justify-start items-end gap-1.5 sm:gap-2.5">
                  <div class="text-gray-900 text-4xl sm:text-5xl font-extrabold font-['Poppins'] leading-[40px] sm:leading-[48px]">
                    ${{ plan_price }}
                  </div>
                  <div class="text-gray-500 text-base sm:text-lg font-medium font-['Poppins'] leading-relaxed">
                    /{{ billing_cycle }}
                  </div>
                </div>
              </div>

              <!-- Beneficios -->
              <div class="w-full flex flex-col justify-start items-start gap-3 sm:gap-4">
                <div
                  v-for="(benefit, i) in [
                    propertyLimit,
                    'Exposición automática en 6 portales',
                    'Contacto Directo Sin Intermediarios',
                    'Presencia Profesional Digital',
                    'Optimización y Estadísticas Completas',
                    'Difusión orgánica en redes sociales de Tuin',
                    'Tu propio sitio web personal e inmobiliria disponible en Tuin'
                  ]"
                  :key="i"
                  class="flex items-center gap-3 w-full"
                >
                  <div class="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center">
                    <div class="w-3 h-3 sm:w-3.5 sm:h-3.5 bg-rose-500 rounded-sm"></div>
                  </div>
                  <div class="flex-1 text-gray-500 text-sm sm:text-base font-normal font-['Poppins'] leading-normal">
                    {{ benefit }}
                  </div>
                </div>
              </div>

              <!-- Botón -->
              <fwb-button
                @click="triggerPlanesTab"
                :disabled="!isActiveLocation"
                class="w-full px-4 sm:px-5 py-2 bg-rose-500 rounded-lg flex justify-center items-center gap-2 hover:bg-rose-600 transition-colors"
              >
                <span class="text-white text-sm sm:text-base font-medium font-['Poppins'] leading-tight">
                  Cambiar plan
                </span>
              </fwb-button>
            </div>
        </div>
      </div>
      <!-- Cancelar Suscripción -->
      <div v-if="type_plan != 9 && !scheduled_cancellation">
        <div
          class="w-44 h-5 justify-center text-neutral-500 text-base font-medium font-['Poppins'] underline leading-normal cursor-pointer"
          @click="openCancelModal"
        >
          Cancelar Suscripción
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, computed, onMounted } from "vue";
  import { useStore } from "vuex";
  const store = useStore();
  let session = computed(() => store.getters.getUserSession);
  import { useRouter } from "vue-router";
  let router = useRouter();
  import axios from "axios";
  import { defineEmits } from 'vue';
  
  import { defineProps } from "vue";
  import ConfirmCancelModal from "./modal/confirmCanceledSuscription.vue";

  const emit = defineEmits(['updateSubscription']);
  const props = defineProps({
    userdata: {
      type: Object,
      required: true,
    },
  });
  
  let showPayments = ref(false);
  let plan_name = ref();
  const showCancelModal = ref(false);
  let id_suscription = ref(null);
  let next_payment = ref();
  let toastAlert = ref(false);
  let typeMsg = ref("");
  let msg = ref("");
  let tittle = ref("")
  let plan_price = ref();
  let type_plan = ref();
  let last4_number = ref();
  let type_card = ref();
  let billing_cycle = ref();
  let loader_profile = ref(false);
  let scheduled_cancellation = ref(0);

  const propertyPlans = {
    149: "Hasta 3 propiedades",
    199: "Hasta 5 propiedades",
    399: "Hasta 10 propiedades",
    499: "Propiedades ilimitadas",
    1430: "Hasta 3 propiedades",
    1910: "Hasta 5 propiedades",
    3830: "Hasta 10 propiedades",
    4790: "Propiedades ilimitadas",
  };

  async function getSubscription(userFromParent) {
    try {
      loader_profile.value = true;

      // ✅ Si no tiene stripe_customer_id, igual revisamos si tiene suscripción local
      if (!userFromParent?.info.stripe_customer_id) {
        console.log("Usuario no tiene Stripe ID — Revisando suscripción local...");

        const options = {
          headers: {
            Authorization: `Bearer ${session.value.token_api}`,
          },
        };

        try {
          const response = await axios.get(
            `${process.env.VUE_APP_API_BASE_URL}/broker/getSubscription/${session.value.id}`,
            options
          );

          // Si la suscripción está activa → la mostramos
          if (response.status === 200 && response.data.status === "active") {
            plan_price.value = new Intl.NumberFormat('es-MX', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format(response.data.data.amount);
            type_plan.value = response.data.data.plan_id;
            scheduled_cancellation.value = response.data.data.scheduled_cancellation;
            plan_name.value = response.data.data.plan?.name || "Plan Business";
            next_payment.value = formatDate(response.data.data.ends_at);
            last4_number.value = response.data.data.card_last4;
            type_card.value = response.data.data.card_brand;
            billing_cycle.value = response.data.data.billing_cycle === "monthly"
              ? "mensual"
              : response.data.data.billing_cycle === "annual"
              ? "anual"
              : response.data.data.billing_cycle;
            id_suscription.value = response.data.data.stripe_subscription_id;
            showPayments.value = true;
          } else {
            showPayments.value = false;
          }

        } catch (error) {
          console.log("No se encontró suscripción local:", error);
          showPayments.value = false;
        } finally {
          loader_profile.value = false;
        }

        //Salimos aquí y NO seguimos al flujo stripe
        return;
      }

      const options = {
        headers: {
          Authorization: `Bearer ${session.value.token_api}`,
        },
      };

      // ✅ Sincronizar con Stripe (crear o actualizar si es necesario)
      try {
        await axios.get(
          `${process.env.VUE_APP_API_BASE_URL}/broker/stripesave/${session.value.id}`,
          options
        );
      } catch (stripeError) {
        console.log("Error en stripesave:", stripeError);
        // Continuar de todas formas
      }

      // ✅ Traer detalles de suscripción
      const response = await axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/broker/getSubscription/${session.value.id}`,
        options
      );

      if (response.status === 200 && response.data.status === "active") {
        if(response.data.data.plan_id === 9){
          showPayments.value = true;
          type_plan.value = 9;
        }
        else{
          //console.log('respuesta:', response.data)
          plan_price.value = new Intl.NumberFormat('es-MX', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(response.data.data.amount);
          plan_name.value = response.data.data.plan?.name || "Plan Business";
          next_payment.value = formatDate(response.data.data.ends_at);
          last4_number.value = response.data.data.card_last4;
          scheduled_cancellation.value = response.data.data.scheduled_cancellation;
          type_card.value = response.data.data.card_brand;
          billing_cycle.value = response.data.data.billing_cycle === "monthly"
            ? "mensual"
            : response.data.data.billing_cycle === "annual"
            ? "anual"
            : response.data.data.billing_cycle;
          id_suscription.value = response.data.data.stripe_subscription_id;
          showPayments.value = true;
        }
      } else {
        showPayments.value = false;
      }

    } catch (error) {
      const response = error.response;

      if (response?.status === 401) {
        store.dispatch("clearUserSession");
        router.push({ name: "login" });
      } else {
        console.error("Error fetching subscription:", error);
        showPayments.value = false;
      }

    } finally {
      loader_profile.value = false;
    }
  }

  const getCardLogo = (brand) => {
    switch (brand?.toLowerCase()) {
      case 'visa':
        return require('@/assets/imgs/icons/logos_visa.svg');
      case 'mastercard':
        return require('@/assets/imgs/icons/logos_mastercard.svg');
      default:
        return require('@/assets/imgs/icons/credit-card-credit-svgrepo-com.svg');
    }
  };
  const propertyLimit = computed(() => {
    // Normalizar a número (maneja "149.00", "149", 149, null, etc.)
    const raw = plan_price.value;
    if (raw === null || raw === undefined || raw === "") return "Sin propiedades asignadas";

    const num = Math.round(Number(parseFloat(String(raw).replace(/[^0-9.-]+/g, "")) || 0));

    return propertyPlans[num] || "Sin propiedades asignadas";
  });

  async function triggerPlanesTab() {
    emit('goToPlanes', 'planes'); // enviamos el nombre del tab
  }
  function formatDate(dateString) {
    const date = new Date(dateString);
    const months = [
      'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
      'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
    ];

    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  }

  onMounted(async () => {
    try {
      loader_profile.value = true;
      await getSubscription(props.userdata);
    
    } catch (error) {
      console.error("Error al intentar traer los datos", error);
    }
  });

  async function cancelSuscription(suscription) {
    loader_profile.value = true;
    try {

      const options = {
        headers: {
          Authorization: `Bearer ${session.value.token_api}`,
        },
      };

      // Si NO existe stripe_subscription_id → cancelar por userId
      if (!suscription) {
        await axios.get(
          `${process.env.VUE_APP_API_BASE_URL}/broker/cancelSuscriptionByUser/${session.value.id}`,
          options
        );

        showToast(
          "success",
          "Tu suscripción fue marcada para cancelarse al final del periodo (cancelación local)."
        );

        // 🔥 Recargar después del éxito
        setTimeout(() => location.reload(), 200);

        return;
      }

      // Si sí existe → cancelar con Stripe
      await axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/broker/cancelSuscription/${suscription}`,
        options
      );

      showToast(
        "success",
        "Tu suscripción fue programada para cancelarse al final de tu periodo actual."
      );

      // 🔥 Recargar después del éxito
      setTimeout(() => location.reload(), 200);

    } catch (error) {
      const response = error.response;

      if (response?.status === 401) {
        store.dispatch("clearUserSession");
        router.push({ name: "login" });
      } else {
        console.error("Error fetching subscription:", error);
      }

    } finally {
      loader_profile.value = false;
    }
  }
  function openCancelModal() {
    //plan_name.value = propertyId;
    showCancelModal.value = true;
  }
  const confirmCancelSuscription = async () => {
    showCancelModal.value = false;
    loader_profile.value = true;
    await cancelSuscription(id_suscription.value);
  };

  async function showToast(type = null, message = null, tittl = null) {
    toastAlert.value = true;
    typeMsg.value = type;
    msg.value = message;
    tittle.value = tittl;

    setTimeout(() => {
      closeToast();
    }, 3000);
  }
  async function closeToast() {
    toastAlert.value = false;
    typeMsg.value = "";
    msg.value = "";
  }

  //function getProfile() {
  //  showPayments.value = !showPayments.value;
  //}
</script>

